import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { Observable, Subject } from "rxjs";
import { RxFormGroup } from "@rxweb/reactive-form-validators";

@Injectable({
	providedIn: "root",
})
export class MediaClientsService {
	baseUrl = `${environment.apis.base}/media-clients`;

	constructor(private readonly http: HttpClient) {}

	// media-clients.service.ts
	datatable(page?: number, options: any = {}): Observable<any> {
		let httpParams = new HttpParams();

		if (typeof page === "number") {
			httpParams = httpParams.append("page", page);
		}

		if ("key" in options && options.key.trim() !== "") {
			httpParams = httpParams.append("search", options.key);
		}

		// Aquí debes agregar esto para enviar los filtros correctamente:
		if ("client_id" in options && options.client_id) {
			httpParams = httpParams.append("client_id", options.client_id);
		}
		if ("company_client_id" in options && options.company_client_id) {
			httpParams = httpParams.append(
				"company_client_id",
				options.company_client_id,
			);
		}

		return this.http.get<any>(this.baseUrl, { params: httpParams });
	}

	createOrUpdate(data: RxFormGroup, id?: number): Observable<Object> {
		let url = this.baseUrl;

		console.log(data);

		if (id) {
			url += `/${id}`;
			// Si estamos actualizando, enviamos JSON plano, NO FormData
			return this.http.put<any>(url, data.getRawValue());
		}

		// Si estamos creando, sí usamos FormData
		return this.http.post<any>(url, data.toFormData());
	}

	delete(id: number): Observable<Object> {
		const url = `${this.baseUrl}/${id}`;

		return this.http.delete<any>(url);
	}

	getMediasByClientMedia(id: number): Promise<any> {
		let url = `${environment.apis.base}/media-clients/mediaItems/${id}`;

		return this.http.get<any>(url).toPromise();
	}

	getClientMediasActive(): Promise<any> {
		let url = `${environment.apis.base}/media-clients/active`;

		return this.http.get<any>(url).toPromise();
	}

	getClientMediaByCompanie(id: number): Promise<any> {
		let url = `${environment.apis.base}/media-clients/list?company_client_id=${id}`;

		return this.http.get<any>(url).toPromise();
	}
}
